import {
  SerializeMap,
  buildDeserializer,
  buildSerializer,
} from "lib/serializerUtils";

const ledgerAccountSerializeMap: SerializeMap<LedgerAccount> = {
  accountType: "account_type",
  code: "code",
  billingSettingsId: "billing_settings_id",
  description: "description",
  id: "id",
  name: "name",
  masterLedgerAccountIds: "master_ledger_account_ids",
  status: "status",
  xeroAccountId: "xero_account_id",
};

export const serializeLedgerAccount = buildSerializer(
  ledgerAccountSerializeMap,
  "ledgerAccount",
);
export const deserializeLedgerAccount = buildDeserializer(
  ledgerAccountSerializeMap,
  "ledgerAccount",
);
